import { IGameSetting } from "../containers/Keypad/Common/Keypad.actions";
import { ICurrencyFormat } from "../containers/Money/Money.actions";
import { showError } from "../utils/errorHandler";
import { isObject } from "./utils";

export const currencyFormat = (
  currencyFormat: ICurrencyFormat,
  origin?: string
): boolean => {
  if (!isObject(currencyFormat)) {
    showError("Currency has to be an object", origin);
    return false;
  }

  const mandatoryProperties = [
    "iso",
    "decimals",
    "decimalDivider",
    "thousandsDivider",
    "showCurrencyChar"
  ];
  const valueKeys = Object.keys(currencyFormat);

  if (!mandatoryProperties.every(property => valueKeys.includes(property))) {
    showError(
      `Currency object must contain the ${mandatoryProperties.join(
        ","
      )} properties`,
      origin
    );
    return false;
  }

  if (!Number.isInteger(currencyFormat.decimals)) {
    showError(
      "Currency object must have a decimals property of type integer",
      origin
    );
    return false;
  }

  if (currencyFormat.decimals < 2) {
    showError(
      "Currency object must have a decimals property greater than or equal to 2",
      origin
    );
    return false;
  }

  return true;
};

export const balance = (value: number, origin?: string): boolean => {
  if (!Number.isInteger(value)) {
    showError("Balance has to be an integer", origin);
    return false;
  } else if (value < 0) {
    showError("Balance cannot be negative", origin);
    return false;
  }

  return true;
};

export const win = (value: number, origin?: string): boolean => {
  if (value === null) {
    return true;
  } else if (!Number.isInteger(value)) {
    showError("Win has to be an integer if specified", origin);
    return false;
  } else if (value < 0) {
    showError("Win cannot be negative", origin);
    return false;
  }

  return true;
};

export const freeRoundsLeft = (value: number, origin?: string): boolean => {
  if (!Number.isInteger(value)) {
    showError("Rounds has to be an integer", origin);
    return false;
  } else if (value < 0) {
    showError("Rounds cannot be negative", origin);
    return false;
  }

  return true;
};

export const volume = (value: number, origin?: string) => {
  if (value < 0) {
    showError("Volume cannot be below 0", origin);
    return false;
  } else if (value > 1) {
    showError("Volume cannot be above 1", origin);
    return false;
  }

  return true;
};

export const gameSetting = (a, b) => {
  return true;
};

export const gameSettings = (
  settings: IGameSetting[],
  state: IGameSetting[],
  origin?: string
) => {
  if (!Array.isArray(settings)) {
    showError("Game settings has to be an array", origin);
    return false;
  } else if (settings.length) {
    let fail = false;

    settings.forEach((setting, i) => {
      if (settings.findIndex(x => x.key === setting.key) !== i) {
        showError(
          `Game setting '${setting.key}' exists more than once in provided settings`,
          origin
        );
        fail = true;
      } else if (typeof setting !== "object") {
        showError(`Game setting [${i}] has to be an object`, origin);
        fail = true;
      } else if (typeof setting.key === "undefined") {
        showError(`Game setting [${i}] key property is missing`, origin);
        fail = true;
      } else if (typeof setting.key !== "string") {
        showError(
          `Game setting [${i}] key property has to be a string`,
          origin
        );
        fail = true;
      } else if (setting.key.length < 1) {
        showError(
          `Game setting [${i}] key property has to be at least 1 character`,
          origin
        );
        fail = true;
      } else if (typeof setting.name === "undefined") {
        showError(
          `Game setting '${setting.key}' name property is missing`,
          origin
        );
        fail = true;
      } else if (typeof setting.name !== "string") {
        showError(
          `Game setting '${setting.key}' name property has to be a string`,
          origin
        );
        fail = true;
      } else if (setting.name.length < 1) {
        showError(
          `Game setting '${setting.key}' name property has to be at least 1 character`,
          origin
        );
        fail = true;
      } else if (typeof setting.value === "undefined") {
        showError(
          `Game setting '${setting.key}' value property is missing`,
          origin
        );
        fail = true;
      }
    });
    return !fail;
  }

  return true;
};
